// Local storage contains only an opaque server device ID, never notification records or preferences.
const key = 'coachsight.pushDevice'
let resetTask: Promise<void> = Promise.resolve()
export function deviceId(): string | undefined {
  return localStorage.getItem(key) || undefined
}
export function rememberDevice(id: string) {
  localStorage.setItem(key, id)
}
export function pushCapability():
  | 'secure'
  | 'install'
  | 'unsupported'
  | 'denied'
  | 'ready' {
  if (!window.isSecureContext) return 'secure'
  const ios =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  if (
    ios &&
    !matchMedia('(display-mode: standalone)').matches &&
    !(navigator as Navigator & { standalone?: boolean }).standalone
  )
    return 'install'
  if (
    !('serviceWorker' in navigator) ||
    !('PushManager' in window) ||
    !('Notification' in window)
  )
    return 'unsupported'
  return Notification.permission === 'denied' ? 'denied' : 'ready'
}
export async function pushRegistration() {
  await resetTask
  const registration = await navigator.serviceWorker.getRegistration()
  if (registration?.waiting || registration?.installing)
    throw new Error('PUSH_WORKER_UNAVAILABLE')
  if (!registration?.active) throw new Error('PUSH_WORKER_UNAVAILABLE')
  return registration
}
export function resetPushDevice(token?: string) {
  const id = deviceId()
  if (id && token)
    void import('@/api/journalPush')
      .then((api) => api.revokePushDevice(id, token))
      .catch(() => {
        /* Browser unsubscription also revokes delivery. */
      })
  localStorage.removeItem(key)
  if (!('serviceWorker' in navigator)) return
  resetTask = resetTask
    .then(async () => {
      const registration = await navigator.serviceWorker.getRegistration()
      const subscription = await registration?.pushManager?.getSubscription()
      if (subscription && !(await subscription.unsubscribe()))
        throw new Error('PUSH_UNSUBSCRIBE_FAILED')
      for (const notification of (await registration?.getNotifications()) || [])
        notification.close()
    })
    .catch(() => {
      // Retry before the next explicit opt-in. Never silently reuse another account's subscription.
      localStorage.setItem('coachsight.pushResetRequired', 'true')
    })
}
export async function ensurePushReset() {
  await resetTask
  if (localStorage.getItem('coachsight.pushResetRequired')) {
    const registration = await navigator.serviceWorker.getRegistration()
    const subscription = await registration?.pushManager?.getSubscription()
    if (subscription && !(await subscription.unsubscribe()))
      throw new Error('PUSH_UNSUBSCRIBE_FAILED')
    localStorage.removeItem('coachsight.pushResetRequired')
  }
}
